import { render, staticRenderFns } from "./Learner.vue?vue&type=template&id=6fa9f2a6&"
import script from "./Learner.vue?vue&type=script&lang=js&"
export * from "./Learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports